import React, {useRef} from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

function PrivacyBanner({auth}) {

    const banner = useRef(null);

    if (auth && auth != "guest") {
        return <React.Fragment></React.Fragment>
    }

    if (localStorage.getItem('seen-cookies-banner')) {
        return <React.Fragment></React.Fragment>
    }
    
    return <div ref={banner} class = "privacy-banner">
				<div class = "banner-wrapper">
					<p>We use cookies to provide and improve our services. By using our site, you consent to cookies. <a href = "/legal/privacy-policy">Learn more</a></p>
					<button onClick = {() => {
                        banner.current.style.display = "none"
                        localStorage.setItem('seen-cookies-banner', true)
                    }}aria-label = "Close" type = "button"><i class="fas fa-times" style={{ fontSize: '15px' }}></i></button>
				</div>
			</div>
}

function Template({auth, updatePermissions, children}) {
    return (
        <React.Fragment>
            <Navbar auth={auth} updatePermissions={updatePermissions} />
            <main class="container-fluid" id="page">
                {children}
            </main>
            
            <PrivacyBanner auth={auth} />
            <footer>
                <Footer auth={auth} />
            </footer>
        </React.Fragment>
    )
}

export default Template
